module.exports = __webpack_public_path__ + "mainassets/img/phone.e24bc8b0.svg";